export function getKeys<T extends Record<string, unknown>>(obj: T) {
  return Object.keys(obj) as [keyof typeof obj];
}

export const getNameValuesFromEnumNames = <T extends Record<string, string>>(namesMap: T) => {
  return Object.entries(namesMap).map(([k, n]) => ({ name: n as T[keyof T], value: k as keyof T }));
};
